import classNames from 'classnames'

import { CardSection } from 'shared/components/CardSection'
import EventDateInfo from './EventDateInfo'
import EventProductPriceInfo from './EventProductPriceInfo'

import styles from 'booking/components/flow-steps/styles.module.scss'
import eventStyles from '../styles.module.scss'

const EventProduct = ({ event, setActiveProduct, selectedEvent }) => (
    <CardSection
        activeSelected={selectedEvent?.rateId === event.rateId}
        notActive
        className={classNames('mt-3', styles.cardSectionUpSell, event.isSoldOut && styles.disabled)}>
        <div
            onClick={e => {
                e.preventDefault()
                if (!event.isSoldOut) {
                    setActiveProduct(event)
                }
            }}
            className={(styles.upSellOptionWrap, eventStyles.eventsProduct)}>
            <EventProductPriceInfo event={event} selectedEvent={selectedEvent} />
            <div className={classNames(eventStyles.eventMoreInfo, event.isSoldOut && eventStyles.disabled)}>
                <div className={eventStyles.eventDesc} dangerouslySetInnerHTML={{ __html: event.eventMoreInfo }} />
            </div>
            <EventDateInfo event={event} selectedEvent={selectedEvent} />
        </div>
    </CardSection>
)

export default EventProduct
